/** 订单中心页（pages/order）业务文案 — 中文 */
export default {
  order: {
    common: {
      outbound: '去程',
      return: '返程',
      roundTrip: '往返',
      oneWay: '单程',
      multiLeg: '多程',
      submit: '提交',
      next: '下一步',
      detail: '明细',
      loading: '加载中...',
      submitting: '提交中...',
      saving: '保存中',
      tip: '提示',
      cancel: '取消',
      confirm: '确定',
      copy: '复制',
      preview: '预览',
      download: '下载',
      unknown: '未知',
      free: '免费',
      success: '成功',
      failed: '失败',
      personal: '个人',
      company: '公司',
      enterprise: '企业',
      pleaseSelect: '请选择',
      save: '保存',
      yuan: '元',
      quantityTimes: '×{count}',
    },
    applyRefund: {
      nav: { title: '申请退票' },
      stepSelectPassengers: '01 选择退票的乘客',
      stepSelectTrips: '02 选择退票的行程',
      stepSelectAddons: '03 选择退订附加产品',
      refundBenefits: '退票权益',
      noBenefits: '暂无可用权益',
      verifyRefundDetail: '核对退款明细',
      orderAmount: '订单金额',
      ticketAmount: '机票金额',
      addonProducts: '附加产品',
      deductions: '需扣款项',
      ticketDeductions: '机票需扣款',
      refundFee: '退票手续费',
      couponDeduction: '优惠券扣款',
      addonNotSelected: '附加产品(未勾选退订)',
      total: '总计：',
      refundTotal: '退￥{amount}',
      estimatedRefund: '预计退款',
      beforeCouponRefund: '优惠券前退款',
      coupon: '优惠券',
      unionPointDeduction: '积点抵值',
      legFeeLine: '{leg}：-￥{fee}',
      selectPassengerRequired: '请选择退票的乘客',
      atLeastOnePassenger: '至少保留一名退票乘客',
      estimatedRefundPoints: '预计退还积点',
      unionPointCount: '{count} 积点',
    },
    confirmRefund: {
      nav: { title: '确认退票信息' },
      contactInfo: '联系信息',
      phonePlaceholder: '请输入手机号',
      contactTip: '十分重要，请确认能联系到您，否则可能影响退票',
      refundMethod: '退款方式',
      originalChannel: '原支付渠道退回',
      refundReason: '退票原因',
      estimatedRefund: '预计退款',
      detail: '明细',
      submitRefund: '提交退票',
      orderAmount: '订单金额',
      ticketAmount: '机票金额',
      addonProducts: '附加产品',
      deductions: '需扣款项',
      ticketDeductions: '机票需扣款',
      refundFee: '退票费',
      couponDeduction: '优惠券扣款',
      addonNotSelected: '附加产品(未勾选退订)',
    },
    refund: {
      nav: { title: '申请退款' },
      orderRefundable: '订单可退款',
      cancelPolicy: '取消政策',
      provideReason: '请提供退款原因',
      feeDisclaimer: '具体退款金额以实际产生的手续费为准',
      serviceFee: '手续费',
      estimatedRefund: '预计退款',
      estimatedRefundPoints: '预计退还积点',
      unionPointCount: '{count} 积点',
      selectReasonRequired: '请选择退款原因',
      reason: {
        planChanged: '出行计划有变',
        wrongBooking: '订错/多订',
        illness: '生病无法出行',
        transportDelay: '交通延误/取消无法出行',
        merchantAgreed: '与商家协商一致退款',
        hotelPoor: '酒店环境/设施差',
        hotelNoRoom: '酒店没房/加价',
        otherChannel: '其他渠道更优惠',
      },
    },
    refundPlane: {
      nav: {
        selectRefundReason: '选择退款原因',
        selectChangeReason: '选择改签原因',
      },
      headerTitleRefund: '请选择你要退票的原因',
      headerTitleChange: '请选择你要改签的原因',
      voluntaryRefund: '自愿退票',
      voluntaryChange: '自愿改签',
      involuntaryRefund: '非自愿退票',
      involuntaryChange: '非自愿改签',
      airlineFeeRule: '按航空公司退改规则收费',
      involuntaryDesc: '航空公司原因导致旅客无法按照原计划出行，如如航班取消、延误、调配错误、航空管制、飞机调配问题等原因，按航空公司退改规则{action}',
      actionRefund: '退票',
      actionChange: '改签',
      processingTimeShort: '处理时间:1-3个工作日',
      refundTimeShort: '退款时间:1-3个工作日',
      processingTimeLong: '处理时间:3-7个工作日',
      refundTimeLong: '退款时间:3-7个工作日',
      selectRefundReason: '请选择退票原因',
      uploadProof: '上传证明材料',
      uploadDesc: '请上传航班取消、延误等证明材料，以便更快处理您的{action}申请',
      toast: {
        uploadSuccess: '上传成功',
        uploadFailed: '上传失败: {msg}',
        uploadFailedRetry: '上传失败，请重试',
        uploadProofRequired: '请上传证明材料',
        selectReasonRequired: '请选择退票原因',
      },
      reason: {
        planChanged: '改变行程，不想飞了',
        wrongBooking: '填错名字、选错日期、选错航班',
        flightDelay: '航班延误或取消、航班时刻变更',
        fullRefund: '形式全退',
        other: '其它',
      },
    },
    refundProgress: {
      nav: { title: '退款进度' },
      progress: '进度',
      refundDetail: '退款明细',
      actualPaid: '用户实际支付金额',
      serviceFee: '手续费',
      actualRefund: '实际退款金额',
      refundReason: '申请退款原因',
    },
    refundProgressPlane: {
      nav: { title: '退票详情' },
      travelReminder: '出行提醒',
      travelReminderColon: '出行提醒:',
      refundPrefix: '已退款￥',
      expectedRefund: '预计退款￥',
      refundProcessing: '退款中',
      refundSuccess: '退款成功',
      refundableProducts: '需退产品',
      ticketPrice: '机票价格',
      actualRefund: '实退金额',
      estimatedReviewCompletion: '预计7个工作日审核完成',
    },
    pay: {
      nav: { title: '支付页' },
      paymentMethods: '支付方式',
      otherPaymentChannels: '其他支付渠道',
      changeCard: '换卡支付',
      confirmPay: '确认付款',
      loadingInstallment: '正在查询可用分期...',
      noInstallment: '不分期',
      installmentPlan: '￥{amount}X{period}期',
      zeroInterest: '0利息',
      withInterestPerPeriod: '含利息¥{amount}/期',
      selectBankCard: '选择银行卡',
      addBankCard: '新增银行卡',
      selectBankCardAction: '选择银行卡',
      noBankCardTip: '暂无银行卡，点击上方添加银行卡支付',
      inputVerifyCode: '输入验证码',
      resend: '重新发送',
      goPay: '去支付',
      complete: '完成',
      inputPlaceholder: '请输入{field}',
      formName: '姓名',
      formIdCard: '身份证号',
      formBankCard: '银行卡号',
      formMobile: '银行卡预留手机号',
      debitCard: '储蓄卡',
      creditCard: '信用卡',
      paymentMethodTitle: '付款方式',
      noPaymentMethods: '暂无支付方式',
      paymentPrivilege: '支付享特权',
      gotIt: '我知道了',
      couponTipTitle: '优惠提示',
      couponTipText: '您有更优惠的券可使用，最高可优惠￥{amount}，是否立即使用？',
      useCoupon: '去使用',
      discountOff: '减￥{amount}',
      amountTipUnder10: '订单支付金额满10元可享更多银行分期哦~',
      amountTipUnder100: '订单金额满100元解锁更多银行分期',
      unionpayPromoTip: '银联活动满2000-100元，可叠加下面银行满减活动',
      tagInterestFree: '免息',
      tagFullPayment: '全款',
      agreementTitle: '中金支付协议',
      agreementBody: '本人授权并同意0息游出行小程序将本人的手机号传输给信用卡分期产品使用，并通过0息游出行小程序将本人在信用卡分期产品绑定相关信用卡的结果反馈给0息游出行小程序用于向本人展示和查询，便于本人在0息游出行小程序购买打车产品或服务使用信用卡分期产品进行分期付款时直接选卡。',
      toast: {
        paySuccess: '支付成功',
        payCancelled: '支付取消',
        payFailed: '支付失败',
        selectBankFirst: '请先选择银行卡',
        fillComplete: '请填写完整',
        sendingCode: '验证码发送中...',
        payRequestFailed: '支付请求失败，请稍后重试',
        orderAmountFailed: '订单金额获取失败，请返回订单列表重试',
        selectPaymentMethod: '请选择支付方式',
        installmentNotEligible: '商品类型或金额不满足此分期数',
        switchingBestCoupon: '正在为您切换到最优惠券...',
        queryPayResult: '查询支付结果中',
        alipayBrowserOnly: '支付宝支付需要在手机浏览器使用',
        openAppletFail101: '小程序 appId 为空，无法跳转',
        openAppletFail102: '未找到目标小程序，无法跳转',
        openAppletFailUnknown: '打开小程序失败，请稍后重试',
      },
    },
    invoice: {
      nav: { title: '开发票' },
      stepSelectType: '01 选择开票类型',
      stepFillInfo: '02 填写开票信息',
      stepDelivery: '03 填写配送信息',
      eVoucherTip: '电子凭证与纸质凭证有同等的法律效力，且无需快递',
      eInvoice: '电子普通发票',
      fillTitleTip: '电子普通发票需填写抬头，默认全部开票用同一抬头',
      titleGuideTip: '如自己购买，填写自己的名字。如单位购买，需要报销，填写单位名称',
      invoiceTitle: '开票抬头',
      invoiceNotes: '发票备注',
      notesGuide: '您可向贵公司财务确认是否需要添加备注信息',
      notesLimit: '(仅电子普通发票支持展示备注，保险发票除外)',
      email: '电子邮箱',
      emailPlaceholder: '邮箱号用于接收电子凭证',
      invoiceAmount: '开票金额',
      invoiceDetail: '开票明细',
      editTitle: '编辑发票抬头',
      addTitle: '新增发票抬头',
      addPersonalTitle: '新增个人发票抬头',
      addEnterpriseTitle: '新增企业发票抬头',
      addPersonalInfo: '新增个人信息',
      selectPassengers: '选择开票乘客',
      selectTitle: '选择发票抬头',
      selectPersonalInfo: '选择个人信息',
      selectEnterpriseTitle: '选择企业发票抬头',
      idNumber: '证件号：{number}',
      idNumberLabel: '证件号码',
      taxNumber: '税号：{number}',
      personalTitle: '个人抬头',
      enterpriseTitle: '企业抬头',
      taxpayerId: '纳税人识别号',
      personalTitlePlaceholder: '请填写个人抬头',
      idNumberPlaceholder: '请填写证件号码',
      enterpriseTitlePlaceholder: '请填写企业抬头',
      taxpayerIdPlaceholder: '请填写纳税人识别号',
      verifyDetail: '开票明细核对',
      couponNoInvoice: '优惠券支付的部分无法提供发票',
      sendTimeTip: '电子普通发票发送时间：最早在订单完成后发送，通常当天可发送。',
      invoiceInfo: '开票信息',
      titleWillShow: '全部电子发票将展示开票抬头',
      notesWillShow: '电子发票将展示发票备注',
      deliveryInfo: '配送信息',
      orderNoWithTime: '{time} | 订单号：{orderNo}',
      hotelName: '酒店名称：{name}',
      checkIn: '入住：{date}',
      checkOut: '离店：{date}',
      productName: '产品名称：{name}',
      travelDate: '游玩时间：{date}',
      carTrip: '从{from}出发，到{to}',
      trainTravelDate: '出行日期：{date}',
      trainSeat: '车次座位：{info}',
      passengerCount: '乘车人数：{count}人',
      trainTicketAmount: '火车票金额',
      amount: '金额',
      insuranceAmount: '保险金额',
      ticketPriceDetail: '票价明细：￥{ticketPrice}（票价）+ ￥{servicePrice}（服务费）= ￥{totalPrice}',
      trainPassengers: '乘车人：{names}',
      backToEdit: '返回修改',
      train12306Guide: '请先选择开票类型，然后选择乘客和{target}',
      train12306TargetPersonal: '个人信息、企业发票抬头',
      train12306TargetTitle: '发票抬头',
      train12306MultiTipPersonal: '个人信息可多选，企业发票抬头只能单选',
      train12306MultiTipTitle: '个人发票抬头可多选',
      sendAfterTicket: '所有产品出票后发送',
      sendAfterCheckout: '退房后发送',
      sendAfterComplete: '订单完成后发送',
      productType: {
        plane: '机票',
        hotel: '酒店',
        tourism: '旅游',
        train: '火车票',
        intlPlane: '国际机票',
        intlHotel: '国际酒店',
        car: '用车',
      },
      noteTab: {
        orderNo: '订单号',
        tripInfo: '行程信息',
        flightNo: '航班号',
        passengers: '乘机人',
        hotelDates: '酒店名和入离日期',
        travelDate: '旅游日期',
        destination: '目的地',
        scenicName: '景点名称',
        travelers: '游玩人员',
        trip: '行程',
        date: '日期',
        trainInfo: '车次信息',
        trainPassengers: '乘车人',
      },
      notes: {
        orderNo: '订单号:{orderNo}',
        roundTripRoute: '往返 {from}到{to}',
        oneWayRoute: '单程 {from}到{to}',
        roundTripFlight: '往返 去：{outbound}回：{inbound}',
        oneWayFlight: '单程 {flightNum}',
        passengers: '乘机人：{names}',
        multiRoute: '多程航线: {from}到{to}等',
        route: '航线: {from}到{to}',
        tripInfo: '行程信息',
        intlFlights: '国际航班: {flightNums}',
        flightNo: '航班号',
        passenger: '乘机人',
        hotelStay: '{hotelName} 入住：{checkIn} 离店：{checkOut}',
        travelDate: '旅游日期:{date}',
        destination: '目的地:{name}',
        scenicName: '景点名称:{name}',
        travelers: '游玩人员:{names}',
        carTrip: '从{from}到{to}',
        date: '日期:{date}',
        trainTrip: '行程信息: {from}到{to}',
        trainNumber: '车次: {info}',
        trainPassengers: '乘车人：{names}',
        trainPassenger: '乘车人',
      },
      toast: {
        selectPassenger: '请选择乘客',
        selectTitle: '请选择发票抬头',
        selectPersonalInfo: '请选择个人信息',
        selectEnterpriseTitle: '请选择企业发票抬头',
        fillEmail: '请填写电子邮箱',
        selectPassengerTitle: '请选择{label}',
        submitFailed: '提交失败，请重试',
        titleExceedPassengers: '抬头选择数量不能超过乘客数量',
        titleNotInPassengers: '该抬头不在已选乘客中，请确认',
        personalIdRequired: '个人抬头需补充身份证号',
        personalInfoExceed: '个人信息选择数量不能超过乘客数量',
        personalInfoNotInPassengers: '该个人信息不在已选乘客中，请确认',
        personalInfoIdRequired: '个人信息需补充身份证号',
        deleteSuccess: '删除成功',
        passengerListFailed: '获取乘客列表失败',
        fillTitle: '请填写抬头',
        fillIdNumber: '请填写证件号码',
        fillTaxpayerId: '请填写纳税人识别号',
        saveSuccess: '保存成功',
        deleteConfirm: '是否删除该抬头',
        selectCountMismatch: '请选择{required}个{label}，当前已选{selected}个',
        titleShort: '抬头',
        personalInfoShort: '个人信息',
      },
    },
    invoiceDetail: {
      nav: { title: '发票详情' },
      orderNo: '订单号：{orderNo}',
      travelOn: '{date} {time} 出行',
      passengers: '乘机人：{names}',
      hotelName: '酒店名称：{name}',
      checkIn: '入住：{date}',
      checkOut: '离店：{date}',
      guest: '入住人：{name}',
      productName: '产品名称：{name}',
      travelDate: '游玩时间：{date}',
      travelers: '出行人：{names}',
      carTrip: '从{from}出发，到{to}',
      insuranceType: '险种：{name}',
      insured: '被保人：{names}',
      transferCount: '中转{count}次',
      passenger: '乘客：{names}',
      trainInfo: '车次：{info} {date} {time} 出行',
      segmentTag: '第{index}段',
      invoiceTitle: '发票抬头：{title}',
      eInvoice: '电子普通发票',
      amount: '金额',
      amountWithCount: '￥{amount}*1张',
      otherInfo: '其他信息',
      applyTime: '申请时间：',
      email: '电子邮件：',
      emailAddress: '{email}(发票发送地址)',
      tip: '提示：',
      tipSevenDays: '预计七个工作日发票会发到指定邮箱中',
      downloadLink: '发票下载链接',
      downloadLinkHint: '请复制到浏览器下载',
      previewDownload: '发票预览下载',
      previewDownloadHint: '点击预览、下载或复制链接',
      imageIndex: '（第{index}张）',
      toast: {
        fetchFailed: '获取发票详情失败',
        invalidDownloadLink: '下载链接无效',
        saveSuccess: '保存成功',
        savePermission: '需要保存图片权限，请在设置中打开',
        parseFailed: '图片解析失败',
        invalidPreviewLink: '预览链接无效',
        previewFailed: '预览失败，请稍后重试',
        previewError: '预览出错，请稍后重试',
        orderDetailFailed: '获取订单详情失败',
      },
    },
    invoiceSuccess: {
      nav: { title: '提交成功' },
      title: '提交成功',
      subtitle: '您的发票申请已成功提交',
      invoiceInfo: '发票信息',
      eInvoice: '电子发票',
      issueAfterComplete: '订单完成后出票',
      reimbursementAmount: '报销金额',
      applyTime: '申请时间',
      backHome: '返回首页',
      invoiceDetail: '开票详情',
      selectInvoice: '选择发票',
      unnamedInvoice: '未命名发票',
      amount: '金额：￥{amount}',
      invoiceTime: '开票时间：{time}',
      toast: {
        noInvoiceInfo: '暂无发票信息',
        queryFailed: '查询失败',
      },
    },
  },
}
